import * as React from 'react'

import TakeCareIcon from './vec_support_memo_arrival_pink_24.svg?reactCompornt'
import EatingIcon from './vec_support_memo_milk_pink_24.svg?reactCompornt'
import ExcretionIcon from './vec_support_memo_poo_pink_24.svg?reactCompornt'
import SleepIcon from './vec_support_memo_sleep_pink_24.svg?reactCompornt'
import GoingOutIcon from './vec_support_memo_outing_pink_24.svg?reactCompornt'
import TemperatureIcon from './vec_support_memo_temperature_pink_24.svg?reactCompornt'
import BathingIcon from './vec_support_memo_bathing_pink_24.svg?reactCompornt'
import PlayingIcon from './vec_support_memo_playing_pink_24.svg?reactCompornt'
import OtherIcon from './vec_support_memo_other_pink_24.svg?reactCompornt'
import FinishIcon from './vec_support_memo_wake_up_pink_24.svg?reactCompornt'
import CloseIcon from './close.svg?reactCompornt'

import * as Style from './style.css'

export interface IProps {
  disabledFinish?: boolean
  clickHandler: (supportEventType: ISupportEventType) => void
  closeHanlder: () => void
}

const SUPPORT_EVENT_TYPE_TAKECARE = 'TakeCare'
const SUPPORT_EVENT_TYPE_EATING = 'Eating'
const SUPPORT_EVENT_TYPE_EXCRETION = 'Excretion'
const SUPPORT_EVENT_TYPE_SLEEP = 'Sleep'
const SUPPORT_EVENT_TYPE_GOINGOUT = 'GoingOut'
const SUPPORT_EVENT_TYPE_TEMPERATURE = 'Temperature'
const SUPPORT_EVENT_TYPE_BATHING = 'Bathing'
const SUPPORT_EVENT_TYPE_PLAYING = 'Playing'
const SUPPORT_EVENT_TYPE_OTHER = 'Other'
const SUPPORT_EVENT_TYPE_HANDOVER = 'Handover'
const SUPPORT_EVENT_TYPE_FINISH = 'Finish'

export const SupportEventModal = ({
  disabledFinish,
  clickHandler,
  closeHanlder,
}: IProps): JSX.Element => (
  <div className={Style.SupportEventModal}>
    <div className={Style.SupportEventModalHeader}>
      <p className={Style.SupportEventModalTtile}>保育内容</p>
      <button
        type="button"
        className={Style.SupportEventModalClose}
        onClick={closeHanlder}
      >
        <CloseIcon />
      </button>
    </div>
    <ul className={Style.SupportEvents}>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_TAKECARE)}
        >
          <TakeCareIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>お預かり</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_EATING)}
        >
          <EatingIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>飲食</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_EXCRETION)}
        >
          <ExcretionIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>排泄</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_SLEEP)}
        >
          <SleepIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>睡眠</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_GOINGOUT)}
        >
          <GoingOutIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>外出</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_TEMPERATURE)}
        >
          <TemperatureIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>体温</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_BATHING)}
        >
          <BathingIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>お風呂</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_PLAYING)}
        >
          <PlayingIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>遊び</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_OTHER)}
        >
          <OtherIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>その他</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={Style.SupportEvent}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_HANDOVER)}
        >
          <TakeCareIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>引き渡し</span>
        </button>
      </li>
      <li className={Style.SupportEventsItem}>
        <button
          type="button"
          className={
            disabledFinish ? Style.SupportEventDisabled : Style.SupportEvent
          }
          disabled={disabledFinish}
          onClick={() => clickHandler(SUPPORT_EVENT_TYPE_FINISH)}
        >
          <FinishIcon className={Style.SupportEventIcon} />
          <span className={Style.SupportEventName}>サポート終了</span>
        </button>
      </li>
    </ul>
  </div>
)
